<template>
    <LoaderSplash :loaded="loaded">
        <b-container v-if="loaded">
            <b-row>
                <b-col>
                    <router-link class="my-3 d-inline-block" :to="{ name: 'event', params: { id: event.id }}">
                        Back to All Invites
                    </router-link>

                    <h2>
                        Create an invitation to {{ event.name }}
                    </h2>

                    <b-form @submit.prevent="onSubmit">
                        <b-form-group>
                            <label>
                                First Name
                            </label>

                            <b-form-input
                                type="text"
                                v-model="form.first_name"
                                required>    
                            </b-form-input>

                            <label>
                                Last Name
                            </label>

                            <b-form-input
                                type="text"
                                v-model="form.last_name"
                                required>    
                            </b-form-input>

                            <label>
                                Phone
                            </label>

                            <b-form-input
                                type="text"
                                v-model="form.phone"
                                required>    
                            </b-form-input>

                            <label>
                                Email
                            </label>

                            <b-form-input
                                type="text"
                                v-model="form.email"
                                required>    
                            </b-form-input>

                            <div v-for="custom_field in form.custom_fields" :key="custom_field.name">
                                <label>
                                    {{toTitleCase(custom_field.name)}}
                                </label>

                                <b-form-input
                                        type="text"
                                        v-model="custom_field.value">
                                </b-form-input>
                            </div>

                            <b-button type="submit" variant="primary">
                                Create Invite
                            </b-button>
                        </b-form-group>
                    </b-form>

                    <hr class="mt-5">

                    <h3>
                        Or, upload a list of invitations
                    </h3>

                    <p>
                        Upload a CSV list of invitees to add to the current event. <br>

                    </p>
                    <p v-html="csvInstructionsHtml"></p>


                    <b-form @submit.prevent="onSubmitCSV">
                        <b-form-group>
                            <b-form-file
                                class="mb-2"
                                v-model="csv_file"
                                placeholder="Choose a file"
                            >
                            </b-form-file>

                            <b-button type="submit" variant="primary" :disabled="!csv_file">
                                Upload
                            </b-button>
                        </b-form-group>
                    </b-form>
                </b-col>
            </b-row>
        </b-container>
    </LoaderSplash>
</template>

<script>
    import inviteRepository from "@/repository/invites";
    import eventRepository from "@/repository/events";
    import parser from 'csv-parse/lib/es5';

    export default {
        props: ['id'],

        data() {
            return {
                form: {
                    event_id: null,
                    first_name: "",
                    last_name: "",
                    phone: "",
                    email: "",
                    custom_fields:[],
                },
                csv_file: null,
                event: null,
                errors: {},
                loaded: false
            }
        },
        
        mounted() {
            eventRepository.getById(this.id, {
                include: ['client']
            })
                .then(response => {
                    this.event = response.data;
                    response.data.client.custom_invite_fields.forEach(field => {
                        this.form.custom_fields.push(
                            {
                                name: field.name,
                                value:''
                            }
                        )
                    });
                    this.loaded = true;
                });
        },

        computed:{
            csvInstructionsHtml(){
                return `The CSV list should have the following columns:
                            <ul>
                                <li>
                                    ${[...[ 'first_name', 'last_name', 'phone', 'email'], ...this.form.custom_fields.map(f=>f.name)].join('</li><li>')}
                                </li>
                            </ul>`;
            }
        },

        methods: {
            onSubmit() {
                this.storeInvite(this.form, 'Form Errors');
            },

            storeInvite(invite, fail_notification_title) {
                invite.event_id = this.event.id;

                inviteRepository.store(invite)
                    .then(response => {
                        this.$notify({
                            group: 'main',
                            type: 'success',
                            title: 'Invite created',
                            text: 'Invite successfully created.'
                        });

                        this.clear();
                    })
                    .catch(error => {
                        console.log(error);
                        if (error.response.status == 422) {
                            let e = error.response.data.errors;

                            let errors = Object.keys(e).map(key => {
                                return e[key].join("<br/>");
                            }).join("<br/>");

                            this.$notify({
                                group: 'main',
                                type: 'error',
                                title: fail_notification_title,
                                text: errors,
                                duration: 10000
                            });
                        }
                    });
            },

            onSubmitCSV() {
                let required_fields = ['first_name', 'last_name', 'email'];

                let reader = new FileReader();
                reader.readAsBinaryString(this.csv_file);
                reader.onloadend = () => {
                    parser(reader.result, {}, (errors, output) => {
                        if (errors !== undefined) {
                            // handle parser errors
                        } else {
                            let head = output[0];
                            let rows = output.slice(1);
                            let missing_fields = [];

                            for (let field of required_fields) {
                                if (head.indexOf(field) == -1) {
                                    missing_fields.push(field);
                                }
                            }

                            if (missing_fields.length) {
                                this.$notify({
                                    group: 'main',
                                    type: 'error',
                                    title: "Missing Columns Error",
                                    text: "Your CSV file is missing the following columns: " + missing_fields,
                                    duration: 10000
                                });

                                return;
                            }

                            for (let row of rows) {
                                // create new invite object by matching values
                                // to required fields
                                let invite = Object.assign(
                                    ...head.map((k, i) => ({ [k]: row[i] }))
                                );

                                this.storeInvite(invite, "CSV Row Error");
                            }
                        }
                    });
                }
            },  

            toTitleCase(str){
                return str.replace(/_/,' ').replace(/\b\S/g, t => t.toUpperCase());
            },

            clear() {

                //this was causing an error, as it doesnt handle custom fields well
                // for (field in this.form) {
                //     this.form[field] = "";
                // }
                this.form.first_name = "";
                this.form.last_name = "";
                this.form.phone = "";
                this.form.email = "";
                this.form.custom_fields.forEach(cf=>cf.value='');
            }
        }
    }
</script>

<style scoped>

</style>